import { SubCategoryForm } from "./components/SubCategoryForm";

export function CreateSubCategoryPage() {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Crear Subcategoría</h2>
        <p className="text-gray-600 mt-1">
          Completa el formulario para crear una nueva subcategoría vinculada a una disciplina
        </p>
      </div>
      <SubCategoryForm />
    </div>
  );
}
